import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import { fetcheventsunderClients } from "AccountSettingsAction";
import ReportissueHeader from "./reportheader";
import CloseReportIssue from "./closedissue";
import OpenReportIssue from "./openissue";
import LocaleStrings from "Languages";

class ReportIssue extends Component {
  constructor(props) {
    super(props);
    // this.state = this.getInitialState();
    this.state = {
      selectedTab: 1,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    let { session, user } = this.props;
    let clientid = user.clientid;
    this.props.fetcheventsunderClients(session, clientid);
  }

  handleSelect(key) {
    this.setState({ selectedTab: key });
  }

  render() {
    let { selectedTab } = this.state;

    return (
      <div className="panel noborder-panel">
        <ReportissueHeader />

        <div className="panel-body">
          <Tabs
            id="client_report_tickets"
            activeKey={selectedTab}
            onSelect={this.handleSelect}
          >
            <Tab eventKey={1} title={LocaleStrings.accountsetting_tab_title1}>
              <OpenReportIssue />
            </Tab>
            <Tab eventKey={2} title={LocaleStrings.accountsetting_tab_title2}>
              <CloseReportIssue />
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user } = state;

  return {
    session,
    user,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetcheventsunderClients,
})(ReportIssue);
